/** Server-driven widget extras (appearance, pre-chat, WhatsApp hand-off). Absent keys mean today's behaviour. */
export interface ChatExtras {
  appearance?: { color?: string; position?: 'right' | 'left'; title?: string; mode?: 'light' | 'dark' | 'auto' };
  prechat?: { enabled: boolean; askName: boolean; askPhone: boolean; phoneRequired: boolean };
  whatsappHandoff?: { enabled: true; label: string };
}
export interface VisitorInfo { name?: string; phone?: string }

const COLOR = /^#[0-9a-f]{6}$/i;   // strict: the value reaches a CSS custom property
const TITLE_MAX = 40;
export const DEFAULT_HANDOFF_LABEL = 'Continue on WhatsApp';
const record = (v: unknown): Record<string, unknown> | null => v && typeof v === 'object' && !Array.isArray(v) ? v as Record<string, unknown> : null;

export function parseExtras(boot: unknown): ChatExtras | undefined {
  const b = record(boot); if (!b) return undefined;
  const out: ChatExtras = {};
  const a = record(b.appearance);
  if (a) {
    const appearance: NonNullable<ChatExtras['appearance']> = {};
    if (typeof a.color === 'string' && COLOR.test(a.color)) appearance.color = a.color.toLowerCase();
    if (a.position === 'right' || a.position === 'left') appearance.position = a.position;
    if (a.mode === 'light' || a.mode === 'dark' || a.mode === 'auto') appearance.mode = a.mode;
    if (typeof a.title === 'string' && a.title.trim()) appearance.title = Array.from(a.title.trim()).slice(0, TITLE_MAX).join('');
    if (Object.keys(appearance).length) out.appearance = appearance;
  }
  const p = record(b.prechat);
  if (p) out.prechat = { enabled: p.enabled === true, askName: p.ask_name === true, askPhone: p.ask_phone === true, phoneRequired: p.phone_required === true };
  const h = record(b.whatsapp_handoff);
  if (h && h.enabled === true) out.whatsappHandoff = { enabled: true, label: typeof h.label === 'string' && h.label.trim() ? h.label.trim() : DEFAULT_HANDOFF_LABEL };
  return Object.keys(out).length ? out : undefined;
}

/** The only url the SDK will offer for a hand-off. Mirrors the builder in osvi-platform-backend app/controllers/public_chat_controller.rb (whatsapp_handoff): `https://wa.me/<digits>?text=<url-encoded>`. */
export const isWhatsAppUrl = (u: unknown): u is string => typeof u === 'string' && /^https:\/\/wa\.me\/[0-9]+(\?[^\s#]*)?$/.test(u);
